/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ScreenerBedRoom } from './ScreenerBedRoom';
import {
    ScreenerBedRoomFromJSON,
    ScreenerBedRoomFromJSONTyped,
    ScreenerBedRoomToJSON,
    ScreenerBedRoomToJSONTyped,
} from './ScreenerBedRoom';

/**
 * 
 * @export
 * @interface BulkUpdateBedRoomsRequest
 */
export interface BulkUpdateBedRoomsRequest {
    /**
     * 
     */
    rooms: Array<ScreenerBedRoom>;
}

/**
 * Check if a given object implements the BulkUpdateBedRoomsRequest interface.
 */
export function instanceOfBulkUpdateBedRoomsRequest(value: object): value is BulkUpdateBedRoomsRequest {
    if (!('rooms' in value) || value['rooms'] === undefined) return false;
    return true;
}

export function BulkUpdateBedRoomsRequestFromJSON(json: any): BulkUpdateBedRoomsRequest {
    return BulkUpdateBedRoomsRequestFromJSONTyped(json, false);
}

export function BulkUpdateBedRoomsRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): BulkUpdateBedRoomsRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'rooms': ((json['rooms'] as Array<any>).map(ScreenerBedRoomFromJSON)),
    };
}

export function BulkUpdateBedRoomsRequestToJSON(json: any): BulkUpdateBedRoomsRequest {
    return BulkUpdateBedRoomsRequestToJSONTyped(json, false);
}

export function BulkUpdateBedRoomsRequestToJSONTyped(value?: BulkUpdateBedRoomsRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'rooms': ((value['rooms'] as Array<any>).map(ScreenerBedRoomToJSON)),
    };
}

